// extracted by mini-css-extract-plugin
export default {"container":"RegionDrag_container__DLilS","image":"RegionDrag_image__hB7NN"};